import axios from 'core/common/config/axios-config';
import {LovItem} from "core/metamodel/mdEntity";


export function optionsSearch(entityName: string, params: any, searchTerm?: string): Promise<{options: LovItem[]}> {
  console.log("searching %s, params = %o, serarchTerm = %o", entityName, params, searchTerm);
  return axios.get('/core/meta/search/' + entityName, {params: Object.assign({searchTerm}, params)})
    .then(response => ({options: response.data}));
}



// WEBPACK FOOTER //
// ./src/core/common/service/commonDataService.ts